import { Dispatch, useContext, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import { Colors, Fonts } from '../../../../config/theme';
import styled from 'styled-components';
import { ProductListingContext } from '../../functions/data_formatting_functions';
import { actionSetListingData } from '../../store/create_listing_actions';
import { all_packages_list } from '../../constants';
import { CardStyled } from '../../../../styles/style';
import Error from '../../../../components/error';
import { ListingState } from '../../../../data/types/listings';
import { Button } from '@nextui-org/react';
import { FaWandMagic } from 'react-icons/fa6';
import UtilitiesRepository from '../../../../data/repositories/utilities_repository';

type ShippingProps = {
  addStep: () => void;
  remove: () => void;
};

export default function Shipping({ addStep, remove }: ShippingProps) {
  const {
    state,
    dispatch,
  }: {
    state: ListingState;
    dispatch: Dispatch<any>;
  } = useContext(ProductListingContext);
  const [errors, setErrors] = useState({
    whats_included: '',
    time_to_ship: '',
    weight: '',
    width: '',
    length: '',
    height: '',
  });
  console.log('shipping screen state: ', state);
  const [active_package, setPacakge] = useState('Other');
  const updateWhatsInBox = (value: string) => {
    dispatch(actionSetListingData({ ...state.data, whats_included: value }));
  };

  const setPackageDimentions = (p: any) => {
    setPacakge(p.name ?? 'Other');
    dispatch(
      actionSetListingData({
        ...state.data,
        width: p.width,
        height: p.height,
        length: p.length,
      }),
    );
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const name = e.target.name;
    const value = e.target.value;
    dispatch(actionSetListingData({ ...state.data, [name]: value }));
  };

  const handleChangeQuality = (name: string) => {
    dispatch(
      actionSetListingData({
        ...state.data,
        [name]: !state.data[name as keyof typeof state.data],
      }),
    );
  };

  const handleValidations = () => {
    const errorsFields = {
      whats_included: '',
      time_to_ship: '',
      weight: '',
      width: '',
      length: '',
      height: '',
    };
    let error = false;
    Object.keys(state.data).map(function (keyName) {
      const value = state.data[keyName as keyof typeof state.data];

      if (keyName === 'whats_included') {
        if (!value) {
          errorsFields.whats_included = 'ⓘ Description is required.';
          error = true;
        }
        if ((value as string)?.length > 256) {
          errorsFields.whats_included =
            'ⓘ Whats include must be less then 256 characters.';
          error = true;
        }
      }

      if (keyName === 'time_to_ship') {
        if (!value) {
          errorsFields.time_to_ship = 'ⓘ Time to ship is required.';
          error = true;
        }
        if (!(value as string).match(/^[1-9]\d*(\.\d+)?$/)) {
          errorsFields.time_to_ship = 'ⓘ Only numbers are allowed.';
          error = true;
        }
      }

      if (keyName === 'weight') {
        if (!value) {
          errorsFields.weight = 'ⓘ Weight is required.';
          error = true;
        }
        if (!(value as string).match(/^[1-9]\d*(\.\d+)?$/)) {
          errorsFields.weight = 'ⓘ Only numbers are allowed.';
          error = true;
        }
      }
      if (keyName === 'width') {
        if (!value) {
          errorsFields.width = 'ⓘ Width is required.';
          error = true;
        }
      }
      if (keyName === 'length') {
        if (!value) {
          errorsFields.length = 'ⓘ length is required.';
          error = true;
        }
      }
      if (keyName === 'height') {
        if (!value) {
          errorsFields.height = 'ⓘ Height is required.';
          error = true;
        }
      }
    });
    setErrors(errorsFields);
    return error;
  };

  const handelNext = (e: any) => {
    e?.preventDefault && e.preventDefault();
    if (!handleValidations()) {
      return addStep();
    }
  };
  return (
    <>
      <Row>
        <Col lg={7}>
          <CardStyled style={{ paddingBottom: 0 }}>
            <ShippingStyle>
              <div className="head">
                <h1>Shipping</h1>
                <p className="text-secondary">
                  Filling in accurate shipping information is important to
                  maintain a high-quality delivery, please describe in detail
                  what's included in the package, the time it takes to ship and
                  it's weight. Additionaly, state if any of the items are
                  fragile, flammable, or require special handling.
                </p>
              </div>
              <div className="form-group text">
                <label
                  htmlFor="exampleFormControlTextarea1"
                  className="flex justify-between align-items-center"
                >
                  <h6>What is in the box?</h6>
                  <Button
                    isIconOnly
                    color="success"
                    variant="light"
                    onClick={async () => {
                      await UtilitiesRepository.writeListingWhatsInTheBox(
                        state.data.name_en,
                        state.data.name_ar,
                        state.data.description_en,
                        state.data.description_ar,
                      ).then((res) => {
                        if (res) {
                          updateWhatsInBox(res);
                        }
                      });
                    }}
                  >
                    <FaWandMagic />
                  </Button>
                </label>
                <textarea
                  className="form-control"
                  style={{
                    direction: 'rtl',
                  }}
                  placeholder="جهاز آيفون 13 برو، شاحن، سماعات، كتيب التعليمات"
                  rows={5}
                  value={state?.data?.whats_included}
                  name="whats_included"
                  onChange={(e) => updateWhatsInBox(e.target.value)}
                />
                {errors.whats_included ? (
                  <Error text={errors.whats_included} />
                ) : (
                  ''
                )}
              </div>

              <div className="form-group text">
                <label htmlFor="exampleFormControlTextarea1">
                  <h6>Item qualities</h6>
                </label>
                <div className="d-flex justify-content-between mt-3">
                  <div className="checkBoxes d-flex">
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        name="fragile"
                        id="fragile"
                        checked={state.data.fragile}
                        onChange={() => handleChangeQuality('fragile')}
                      />
                      <label className="form-check-label" htmlFor="fragile">
                        Breakable
                      </label>
                    </div>
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        name="flammable"
                        id="flammable"
                        checked={state.data.flammable}
                        onChange={() => handleChangeQuality('flammable')}
                      />
                      <label className="form-check-label" htmlFor="flammable">
                        Flammable
                      </label>
                    </div>
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        name="keep_dry"
                        id="keep_dry"
                        checked={state.data.keep_dry}
                        onChange={() => handleChangeQuality('keep_dry')}
                      />
                      <label className="form-check-label" htmlFor="keep_dry">
                        Keep Dry
                      </label>
                    </div>
                    {/* <div className="form-check"> // TODO reconnect if backend is ready
                      <input
                        className="form-check-input"
                        type="checkbox"
                        name="is_used"
                        id="is_used"
                        checked={state.data.is_used}
                        onChange={(e) => handleChangeQuality('is_used')}
                      />
                      <label className="form-check-label" htmlFor="is_used">
                        Liquid
                      </label>
                    </div> */}
                  </div>
                </div>
              </div>

              <div
                className="dimensions d-flex row"
                style={{ paddingTop: '20px' }}
              >
                {/* <div className="col-lg-4">
                  <h6>Time to prepare (minutes)</h6>
                  <input
                    placeholder="300"
                    name="time_to_ship"
                    value={state.data?.time_to_ship}
                    onChange={(e) => handleChange(e)}
                  />
                  {errors.time_to_ship ? (
                    <Error text={errors.time_to_ship} />
                  ) : (
                    ''
                  )}
                </div> */}
                <div className="col-lg-4">
                  <h6>Package Weight (grams)</h6>
                  <input
                    placeholder="300"
                    name="weight"
                    type="number"
                    value={state.data.weight}
                    onChange={(e) => handleChange(e)}
                  />
                  {errors.weight ? <Error text={errors.weight} /> : ''}
                </div>
              </div>

              <div className="d-flex justify-content-between butns">
                <Button onPress={remove} color="default">
                  Back
                </Button>
                <Button
                  onClick={handelNext}
                  color="success"
                  style={{
                    width: '150px',
                  }}
                >
                  Next step
                </Button>
              </div>
            </ShippingStyle>
          </CardStyled>
        </Col>
        <Col lg={5}>
          <CardStyled
            style={{
              paddingBottom: '5px',
              marginBottom: '0px',
            }}
          >
            <ShippingStyle>
              <div className="head">
                <h1>Packaging</h1>
                <p className="text-secondary">
                  Selecting the package dimensions helps us optimize delivery
                  routes, please be percise as possible regarding the total
                  package size. Note that your delivery may be cancelled if
                  details aren’t exact!
                </p>
              </div>
              <p className="text-secondary">Select a custom size packaging:</p>
              <div className="dimensions d-flex row">
                <div className="col-lg-4">
                  <h6>Width (cm)</h6>
                  <input
                    placeholder="300"
                    value={state?.data?.width}
                    onChange={handleChange}
                    name="width"
                    type="number"
                  />
                  {errors.width ? <Error text={errors.width} /> : ''}
                </div>
                <div className="col-lg-4">
                  <h6>length (cm)</h6>
                  <input
                    placeholder="300"
                    value={state?.data?.length}
                    onChange={handleChange}
                    name="length"
                    type="number"
                  />
                  {errors.length ? <Error text={errors.length} /> : ''}
                </div>
                <div className="col-lg-4">
                  <h6>Height (cm)</h6>
                  <input
                    placeholder="300"
                    value={state?.data?.height}
                    onChange={handleChange}
                    name="height"
                    type="number"
                  />
                  {errors.height ? <Error text={errors.height} /> : ''}
                </div>
              </div>
              <div className="packaging d-flex row">
                <p className="text-secondary">
                  <span
                    style={{
                      color: Colors.greenMain,
                      textDecoration: 'underline',
                    }}
                  >
                    Or choose from the most popular:
                  </span>
                </p>
                {all_packages_list.map((p, index) => {
                  if (index != all_packages_list.length - 1)
                    return (
                      <div
                        key={index}
                        className={` package-box ${
                          active_package === p.name ? 'active' : ''
                        }`}
                        onClick={() => setPackageDimentions(p)}
                      >
                        <span className="title">{p.name}</span>
                        <div className="dimentions">
                          <div className="col-md-6 mt-2">
                            <p>Width up-to: {p.width}cm</p>
                            <p>Length up-to: {p.length}cm</p>
                            <p>Height up-to: {p.height}cm</p>
                          </div>
                          <div className="col-md-6">
                            {/* <SmallParcel
                              active={active_package === p.name ? true : false}
                              width="25px"
                              height="30px"
                            /> */}
                            {p.image}
                          </div>
                        </div>
                      </div>
                    );
                })}
              </div>
            </ShippingStyle>
          </CardStyled>
        </Col>
      </Row>
    </>
  );
}
const ShippingStyle = styled.div`
  font-family: ${Fonts.secondary};
  font-style: normal;
  .back {
    border: 1px solid #05ae4b;
    border-radius: 5px;
  }
  h6 {
    font-weight: 700;
    font-size: 12px;
    color: rgba(0, 39, 51, 0.5);
  }
  .form-check-input:checked {
    background-color: #05ae4b;
  }
  textarea {
    font-weight: 400;
    font-size: 17px;
    line-height: 130%;
    ::placeholder {
      color: rgba(0, 39, 51, 0.2);
    }
  }
  .text {
    padding: 20px 0px;
    border-bottom: 1px solid rgba(0, 39, 51, 0.08);
  }
  .dimensions {
    padding: 20px 0px;
    padding-top: 0px;
    input {
      border: 1px solid #e8e8e8;
      border-radius: 5px;
      width: 90%;
      padding: 11px;
      font-size: 17px;
      color: #002733;
    }
  }
  .package-box {
    padding: 10px;
    border-radius: 10px;
    margin: 2px;
    width: 47%;
    border: 1px solid var(--grey-color);
    .title {
      font-family: ${Fonts.secondary};
      font-weight: 900;
      font-size: 17px;
      color: var(--black-color);
      background: transparent;
    }
    .dimentions {
      /* text-align: center; */
      display: flex;
      justify-content: between;
      p {
        font-family: ${Fonts.secondary};
        font-weight: 400;
        font-size: 12px;
        color: var(--black-color);
        margin: 0px;
        padding: 0px;
      }
      svg {
        margin-top: 20%;
        float: right;
      }
    }
  }
  .package-box.active {
    border: 1px solid var(--theme-clr);
    background: var(--light-theme-clr);
  }
  .form-check {
    padding-right: 20px;
    label {
      padding-left: 4px;
    }
  }
  .quality {
    padding: 20px 0px;
    border-bottom: 1px solid rgba(0, 39, 51, 0.08);
  }

  .butns {
    padding: 20px 0px;
  }
`;
